import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import {playWrongAudio, vibrateWrong} from "../../helpers/sounds";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	root: {
		flexGrow: 1,
		height: "100%"
	},
	extra_level: {
		// height: "150px",
		width: "85%",
		margin: "10px auto",
		borderRadius: "15px",
		padding: "15px",
		display: "flex",
		flexDirection: "row",
		color: "white",
		"user-select": "none",
		"& h3": {
			fontWeight: "normal",
			textAlign: "left",
			margin: "0",
			marginTop: "10px"
		}
	},
	child: {
		backgroundColor: "#2a2a2a",
	},
	extra_level_stats: {
		width: "85%",
		margin: "auto",
		borderRadius: "15px",
		padding: "15px",
		display: "flex",
		flexDirection: "column",
		color: "white",
		"user-select": "none",
	},
	image:{
		maxHeight: "90px",
		pointerEvents: "none",
	},
	header:{
		"& span:nth-child(1)":{
			fontSize: '22px',
			fontWeight: '500',
			textTransform: 'capitalize',
		},
		"& span:nth-child(2)":{
			float: "right"
		}
	},
	slider: {
		color: "white",
		height: "22px",
		margin: "15px auto 0 auto",
		borderRadius: "15px",
		backgroundColor: "rgba(255, 255, 255, 0.5);",
		width: "100%",
		"& > p": {
			margin: "0",
			textAlign: "center",
			position: "absolute",
			left: "57%",
			fontWeight: "600",
			marginTop: "3px"
		},
		"& > span": {
			display: "block",
			float: "left",
			height: "100%",
			backgroundColor: "rgb(255,255,255)",
			position: "relative",
			overflow: "hidden"
		}
	},
	lockedName: {
		"& img": {
			width: "20px;",
			height: "auto",
			verticalAlign: "bottom",
		},
		"& span": {
			fontSize: '22px',
			fontWeight: '500',
			textTransform: 'capitalize',
			paddingLeft: "10px"
		}
	},
	shake: {
		animation: "$shake 0.82s cubic-bezier(.36,.07,.19,.97) both",
		transform: "translate3d(0, 0, 0)",
		backfaceVisibility: "hidden",
		perspective: "1000px"
	},
	"@keyframes shake": {
		"10%, 90%": {
			transform: "translate3d(-1px, 0, 0),"
		},

		"20%, 80%": {
			transform: "translate3d(2px, 0, 0)"
		},

		"30%, 50%, 70% ": {
			transform: "translate3d(-4px, 0, 0)"
		},

		"40%, 60% ": {
			transform: "translate3d(4px, 0, 0)"
		}
	}
});

class LevelWithIcon extends Component {
	state = {
		isShaking: false
	};
	timeoutList = [];

	componentWillUnmount(){
		this.timeoutList.forEach((id) => {
			clearTimeout(id);
		})
	}

	//Kazdy timeout dodajemy do listy, żeby potem wyłączyć przy unmount
	stopShaking = () => {
		this.timeoutList.push(setTimeout(() => {
			this.setState({ isShaking: false })
		}, 1000))
	};


	activateShake = () => {
		if(this.props.isSound){
			playWrongAudio()
		}
		if(this.props.isVibrate){
			vibrateWrong()
		}
		this.setState({ isShaking: true }, this.stopShaking);
	};

	render() {
		const {
			levelName,
			color,
			riddleLimit,
			unlockLimit,
			collectedRiddles,
			riddlesCountingForUnlock,
			isUnlocked,
			classes,
			onClick,
			levelIcon
		} = this.props;
		const { isShaking } = this.state;
		if (isUnlocked) {
			let percentage = collectedRiddles / (riddleLimit) * 100;
			if(percentage < 1 && collectedRiddles > 0){
				percentage = 1
			}

			let percentageFill = percentage;
			if(percentage > 0 && percentage < 3){
				percentageFill = 3
			} else if (percentage > 96 && percentage < 100){
				percentageFill = 96
			}

			return (
				<ButtonBase
					TouchRippleProps={{ classes: { child: classes.child } }}
					component='div'
					className={classes.extra_level}
					style={{ backgroundColor: color }}
					onClick={onClick}
				>
					<img className={classes.image} src={levelIcon} draggable={false} />
					<div className={classes.extra_level_stats}>
						<div className={classes.header}>
							<span>{levelName}</span>
							<span>{collectedRiddles}/{riddleLimit }</span>
						</div>
						<div className={classes.slider}>
							<span
								style={{
									width: `${percentageFill}%`,
									borderRadius: `${
										percentage > 99 ? "15px" : "15px 0 0 15px"
									}`
								}}
							/>
							<p style={{ color: color }}>
								{" "}
								{parseInt(percentage, 10)} %{" "}
							</p>
						</div>
					</div>
				</ButtonBase>
			);
		} else {
			const iconLock = getTranslation("image_level_lock");
			return (
				<ButtonBase
					TouchRippleProps={{ classes: { child: classes.child } }}
					component='div'
					className={`${classes.extra_level} ${
						isShaking ? classes.shake : ""
					}`}
					style={{ backgroundColor: color }}
					onClick={isShaking ? ()=>(null) : this.activateShake}
				>
					<img className={classes.image} src={levelIcon} />
					<div className={classes.extra_level_stats}>
						<div className={classes.lockedName}>
							<img
								src={iconLock}
								alt="Lock"
							/>
							<span>{levelName}</span>
						</div>
						<h3>{getTranslation("extra_level_locked", [unlockLimit - riddlesCountingForUnlock])}</h3>
					</div>
				</ButtonBase>
			);
		}
	};
}

LevelWithIcon.propTypes = {
	color: PropTypes.string,
	unlockLimit: PropTypes.number,
	collectedRiddles: PropTypes.number,
	riddleLimit: PropTypes.number,
	riddlesCountingForUnlock: PropTypes.number,
	levelIcon: PropTypes.string,
	levelName: PropTypes.string,
	isUnlocked: PropTypes.bool,
	isExtra: PropTypes.bool,
	isSound: PropTypes.bool,
	isVibrate: PropTypes.bool,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		shake: PropTypes.string.isRequired,
		extra_level: PropTypes.string.isRequired,
		extra_level_stats: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		header: PropTypes.string.isRequired,
		slider: PropTypes.string.isRequired,
		lockedName: PropTypes.string.isRequired,
	}).isRequired,

};

export default withStyles(styles)(LevelWithIcon);
